export const menuOpenButton = 'menu_open-button';
